module.exports = __webpack_public_path__ + "static/media/something-went-wrong.ccb6f790.svg";